import { render, staticRenderFns } from "./applicationDetail.vue?vue&type=template&id=a60ed186&scoped=true&"
import script from "./applicationDetail.vue?vue&type=script&lang=js&"
export * from "./applicationDetail.vue?vue&type=script&lang=js&"
import style0 from "./applicationDetail.vue?vue&type=style&index=0&id=a60ed186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60ed186",
  null
  
)

export default component.exports